import styled from "styled-components"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const AdressAdditionalInfos = styled.section`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  border-top: 1px solid ${(props) => props.theme.b_color_gradients.b_light};
`

const AdressPlaceIcon = styled(Icon)`
  color: ${(props) => props.theme.b_color_gradients.b_light};
`
const AdressPlaceTitle = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_light};
`
const AdressFooterBack = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const AdressContentColors = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export {
  AdressAdditionalInfos,
  AdressPlaceIcon,
  AdressPlaceTitle,
  AdressFooterBack,
  AdressContentColors,
}
